var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"color":"white","opacity":"0.5","value":_vm.isPageLoading}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"96"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }